import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { SpinnerService } from "./spinner.service";

@Injectable({providedIn:'root'})
export class OtherGamesService {
    isHideHeaderRefreshIcon = new Subject();
}